<div id="loader-wrapper">
  <div id="loader"></div>
  <div class="loader-bg"></div>
  <div class="loader-msg-section">
    {{ message }}
  </div>
  <div class="loader-section section-left"></div>
  <div class="loader-section section-right"></div>
</div>
